const api = {
  base: ""
};

export default api;



// WEBPACK FOOTER //
// ./src/config/api.js